const CashInChannelType = {
  PaymentProcessor: "paymentProcessor",
  Mode: "mode",
  Channel: "cashinChannel",
  ManualBankDepositToSpi: "manual-bank-deposit-spi",
};

export default CashInChannelType;
